import React, { useId } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { CircleHelp } from 'lucide-react';

export function KAHelp({ label, help }) {
  return <Tooltip title={help} arrow describeChild placement="top" enterDelay={150}
    slotProps={{ popper: { sx: { zIndex: 11000 } }, tooltip: { sx: { fontSize: 12, lineHeight: 1.65, maxWidth: 340 } } }}>
    <button className="ka-help" type="button" aria-label={`${label}说明`}><CircleHelp size={15} aria-hidden="true" /></button>
  </Tooltip>;
}

export function KAToggle({ label, help, description, checked, disabled, onChange }) {
  const id = useId();
  return <div className="ka-toggle">
    <div className="ka-toggle-copy">
      <div className="ka-toggle-title">
        <label htmlFor={id}>{label}</label>
        <KAHelp label={label} help={help} />
      </div>
      {description && <p className="ka-muted">{description}</p>}
    </div>
    <label className="switch">
      <input id={id} aria-label={label} type="checkbox" checked={checked} disabled={disabled} onChange={event => onChange(event.target.checked)} />
      <span className="switch-slider" />
    </label>
  </div>;
}
